<template>
    <div>
        <div v-show="!stripeTokenId && showCustomPaymentButton" id="custom-payment-request-button" @click="showStripePaymentRequest()">Set Up Payment</div>
        <div v-show="!stripeTokenId && !showCustomPaymentButton" id="payment-request-button">
            <!-- A Stripe Element will be inserted here. -->
        </div>

        <fieldset v-if="!isBillingAutoFilled">
            <div class="input-group">
                <div class="input-wrapper-lg">
                    <label><span v-if="!signupOnly">*</span>Card Number</label>
                    <div ref="cardNumberElement" class="field"></div>
                </div>
            </div>

            <div class="input-group">
                <div class="input-wrapper-sm">
                    <label class="billing-form-label"><span v-if="!signupOnly">*</span>Exp</label>
                    <div ref="cardExpiryElement" class="field"></div>
                </div>

                <div class="input-wrapper-sm">
                    <label class="billing-form-label"><span v-if="!signupOnly">*</span>CVC</label>
                    <div ref="cardCvcElement" class="field"></div>
                </div>

                <div class="input-wrapper-sm">
                    <label class="billing-form-label">Zip</label>
                    <input type="text" v-model="zip" placeholder="Zip">
                </div>
            </div>

            <div v-if="stripeError" class="error-msg">
                {{ stripeError }}
            </div>
        </fieldset>
    </div>
</template>

<script>

    export default {
        props: {
            stripePublishableKey: String,
            signupOnly: Boolean
        },
        data: function() {
            return  {
                stripe: undefined,
                cardNumber: undefined,
                stripeTokenId: null,
                stripePaymentRequest: null,
                isBillingAutoFilled: false,
                stripeError: null,
                showCustomPaymentButton: false,
                zip: undefined,
                num: undefined
            }
        },
        methods: {
            validate() {
                if(!this.stripeTokenId) {
                    this.getStripeTokenId();
                }
            },
            cardNo(){
                return this.$refs.cardNumberElement.classList.value.split("--")[1];
            },
            expDate(){
                return this.$refs.cardExpiryElement.classList.value.split("--")[1];
            },
            cvcNo(){
                return this.$refs.cardCvcElement.classList.value.split("--")[1];
            },
            getStripeTokenId() {
                // TODO: Null Check
                const options = {
                    address_zip: this.zip
                };
                this.stripe.createToken(this.cardNumber, options)
                    .then(res => {
                        if (!res || !res.token || !res.token.id) {
                            if (res.error)
                            this.stripeError = res.error.message;
                            return;
                        }
                        this.stripeError = null;
                        this.stripeTokenId = res.token.id;
                        this.$emit('tokenRetrieved', this.stripeTokenId);
                    })
                    .catch(err => console.error(err))
            },
            retrieveStripeData(ev) {
                if(!ev) {
                    return;
                }
                this.stripeTokenId = ev.token.id;

                let userData = {
                    email: ev.payerEmail,
                };
                if (ev.shippingAddress) {
                    userData.street1 = ev.shippingAddress.addressLine[0];
                    userData.street2 = ev.shippingAddress.addressLine[1];
                    userData.city = ev.shippingAddress.city;
                    userData.state = ev.shippingAddress.region;
                    userData.postalCode = ev.shippingAddress.postalCode;
                }

                this.$emit('userDataRetrieved', this.stripeTokenId, userData);
                this.isBillingAutoFilled = true;
            },
            showStripePaymentRequest() {
                this.stripePaymentRequest.show();
            },
            setZip(zip) {
                if (zip && !this.zip) {
                    this.zip = zip;
                }
            }
        },
        watch: {
        },
        mounted() {
            // Setup Stripe elements
            this.stripe = Stripe(this.stripePublishableKey);

            const style = {
                base: {
                    fontSize: '15px',
                    // fontFamily: '"futura-pt", , sans-serif'
                }
            };

            this.stripeElements = this.stripe.elements();

            this.cardNumber = this.stripeElements.create('cardNumber', {
                style: style
            });
            this.cardNumber.mount(this.$refs.cardNumberElement);

            const cardExpiryElement = this.stripeElements.create('cardExpiry', {
                style: style
            });
            cardExpiryElement.mount(this.$refs.cardExpiryElement);

            const cardCvcElement = this.stripeElements.create('cardCvc', {
                style: style
            });
            cardCvcElement.mount(this.$refs.cardCvcElement);

            this.stripePaymentRequest = this.stripe.paymentRequest({
                country: 'US',
                currency: 'usd',
                total: {
                    label: 'Crema.co: Add Payment Method',
                    amount: 0,
                },
                requestPayerName: true,
                requestPayerEmail: true,
                requestShipping: true,
                shippingOptions: [
                    // The first shipping option in this list appears as the default option in the browser payment interface.
                    {
                        id: 'free-shipping',
                        label: 'Free shipping',
                        detail: '',
                        amount: 0,
                    }
                ]
            });

            let prButton = this.stripeElements.create('paymentRequestButton', {
                paymentRequest: this.stripePaymentRequest,
            });


            // Check the availability of the Payment Request API first.
            this.stripePaymentRequest.canMakePayment().then( (result) => {
                if (result) {
                    prButton.mount('#payment-request-button');

                    if (this.stripePaymentRequest._queryStrategy[0] !== "APPLE_PAY" ) {
                        this.showCustomPaymentButton = true;
                    }
                } else {
                    document.getElementById('payment-request-button').style.display = 'none';
                    document.getElementById('custom-payment-request-button').style.display = 'none';
                }
            });

            this.stripePaymentRequest.on('token', (ev) => {
                this.retrieveStripeData(ev);
                // TODO: how do i check the payment card in the wallet is ok. ie: not expired?
                ev.complete('success');
            });
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../styles/_variables_home.scss";
    @import "../../styles/common_home.scss";
    @import "../../styles/form_home.scss";

    #payment-request-button {
        max-width: 200px;
        margin-top: 1rem;
        margin-left: auto;
        margin-right: auto;
        padding-bottom: 6px;
    }
    #custom-payment-request-button {
        max-width: 170px;
        margin-top: 1rem;
        margin-left: auto;
        margin-right: auto;
        text-align: center;
        line-height: 3rem;
        border-radius: 4px;
        font-weight: bold;
        color: white;
        background-color: #39325c;
        cursor: pointer;
        /* HACK */
        background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg id='Layer_1' data-name='Layer 1' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 201.19 200'%3e%3cdefs%3e%3cstyle%3e .cls-1 %7b fill: %23fff;%7d %3c/style%3e%3c/defs%3e%3ctitle%3ewallet-33%3c/title%3e%3cpath class='cls-1' d='M155.08,40.28H44.41A21.22,21.22,0,0,0,23.19,61.5v77a21.22,21.22,0,0,0,21.22,21.22H155.08A21.22,21.22,0,0,0,176.3,138.5v-77A21.22,21.22,0,0,0,155.08,40.28Zm12,55.86H130.51A18.48,18.48,0,0,0,117,102.06l-7.21,7.8a14.9,14.9,0,0,1-20.9,0l-9.44-9.23a15.77,15.77,0,0,0-11-4.49H31.74v-.63A10.53,10.53,0,0,1,42.27,85H156.56a10.52,10.52,0,0,1,10.53,10.53Zm0-17.44H31.74V77.56a10,10,0,0,1,10-10H157a10.1,10.1,0,0,1,10.1,10.1Zm0-17.44H31.74V60.12a10,10,0,0,1,10-10H157a10.1,10.1,0,0,1,10.1,10.1Z'/%3e%3c/svg%3e ");
        background-repeat: no-repeat;
        background-position: 150px 50%;
        padding-right: 30px;
        &:hover {
            background-color: darken(#39325c, 5%);
        }
        &:active {
            background-color: lighten(#39325c, 10%);
        }
    }
    @media only screen and (max-width: $max-mobile-sm-width) {
        .input-wrapper-sm input {
            width: 100%;
        }
        .home-form .billing-form-label {
            display: none;
        }
    }
</style>
